import EventEmitter from "./EventEmitter";

export default class Sizes extends EventEmitter
{
    constructor()
    {
        super()

        // サイズの初期化
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        // リサイズイベントの登録
        window.addEventListener('resize', () =>
        {
            this.resize()
        })
    }

    resize()
    {
        // サイズの更新
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        // イベントの発火
        this.trigger('resize')
    }
}